import React from 'react';
import {
  string,
  number,
  func,
  arrayOf,
  oneOfType
} from 'prop-types';
import {
  params,
  string as stringType,
  shape as shapeType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

export const ProductLoader = ({
  itemId,
  domains,
  children
}) => {
  const resp = useProductDeprecated({ itemId, domains, skip: !itemId });
  return children(resp);
};

ProductLoader.displayName = 'ShareBeltProductLoader';

ProductLoader.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    info: shapeType({
      fiscalYear: stringType(),
      productDepartment: stringType(),
      classNumber: stringType()
    })
  })
};

ProductLoader.propTypes = {
  children: func.isRequired,
  domains: arrayOf(string).isRequired,
  itemId: oneOfType([string, number]),
  storeId: string
};

ProductLoader.defaultProps = {
  storeId: ''
};

export default ProductLoader;
